<div class="container mx-auto p-4" *ngIf="canAccess">

  <!-- Header -->
  <div class="flex items-center mb-6">
    <mat-icon (click)="goBack()" class="cursor-pointer mr-4">arrow_back_ios</mat-icon>
    <h2 class="text-xl font-bold m-0">Regalar eSIM</h2>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <!-- Contenido principal -->
  <div *ngIf="!loading">

    <!-- Info del usuario destino -->
    <mat-card class="mb-6 bg-blue-50">
      <mat-card-content class="flex items-center gap-4 py-4">
        <mat-icon class="text-blue-600" style="font-size: 32px; width: 32px; height: 32px;">card_giftcard</mat-icon>
        <div>
          <p class="font-bold m-0">Regalando eSIM a:</p>
          <p class="m-0">{{ targetUserName }}</p>
          <p class="text-sm text-gray-500 m-0">{{ targetUserEmail }}</p>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Vista de búsqueda -->
    <div *ngIf="!showPackages">
      <mat-card class="p-6">
        <h3 class="text-lg font-semibold mb-4">Buscar paquete eSIM</h3>

        <!-- Selector de tipo -->
        <div class="custom-select-box mb-4">
          <div class="custom-select-label">
            <img src="https://cdn.zendy.tel/images/ico-world-black.svg" width="20" alt="Tipo">
          </div>
          <mat-select [(ngModel)]="selectedType" (selectionChange)="onTypeChange()" placeholder="Selecciona tipo">
            <mat-option *ngFor="let type of types" [value]="type">
              {{ type }}
            </mat-option>
          </mat-select>
        </div>

        <!-- Selector de país -->
        <div class="custom-select-box mb-4">
          <div class="custom-select-label">
            <img src="https://cdn.zendy.tel/images/ico-esim-black.svg" width="20" alt="País">
          </div>
          <mat-select
            [(ngModel)]="selectedCountry"
            [disabled]="!isTypeSelected"
            (selectionChange)="onCountryChange()"
            placeholder="Selecciona país">
            <mat-option *ngFor="let country of filteredCountries" [value]="country.code">
              <div class="flex items-center">
                <img [src]="country.image" [alt]="country.country" class="w-6 h-4 mr-2">
                <span>{{ country.country }}</span>
              </div>
            </mat-option>
          </mat-select>
        </div>

        <!-- Botón buscar -->
        <button
          mat-raised-button
          color="primary"
          class="w-full"
          [disabled]="!isCountrySelected"
          (click)="loadPackages()">
          Buscar eSIM
        </button>
      </mat-card>
    </div>

    <!-- Vista de paquetes -->
    <div *ngIf="showPackages">
      <div class="flex items-center mb-4">
        <mat-icon (click)="goBack()" class="cursor-pointer mr-2">arrow_back_ios</mat-icon>
        <h3 class="text-lg font-semibold m-0">{{ countryName | titlecase }}</h3>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <mat-card *ngFor="let package of filteredPackages" class="esim-card cursor-pointer hover:shadow-lg transition-shadow" (click)="selectPackage(package)">

          <mat-card-header class="flex items-start mb-2">
            <div class="header-image-container mr-4">
              <img [src]="package.operador[0].image" [alt]="package.operador[0].operador" class="w-24 h-auto rounded">
              <span class="country-label">{{ capitalizeCountryName(package.country) }}</span>
            </div>
            <div>
              <h4 class="text-black m-0 text-lg font-bold">{{ package.title }}</h4>
              <p class="m-0 text-xl text-red-600 font-bold">{{ package.price | currency:'EUR':'symbol':'1.2-2':'es-ES' }}</p>
              <div class="flex mt-1">
                <div *ngFor="let item of package.operador[0].plan_type?.split('-')">
                  <img width="16" [src]="'./assets/icons/' + item + '_ico.svg'" [title]="item" class="mr-1">
                </div>
              </div>
            </div>
          </mat-card-header>

          <hr class="my-2">

          <mat-card-content>
            <div class="flex items-center mb-1">
              <mat-icon class="text-red-700 mr-2" style="font-size: 18px;">public</mat-icon>
              <span class="font-bold mr-1">Cobertura:</span>
              <span>{{ package.country | titlecase }}</span>
            </div>
            <div class="flex items-center mb-1">
              <mat-icon class="text-red-700 mr-2" style="font-size: 18px;">swap_horiz</mat-icon>
              <span class="font-bold mr-1">Datos:</span>
              <span>{{ package.data }}</span>
            </div>
            <div class="flex items-center mb-1">
              <mat-icon class="text-red-700 mr-2" style="font-size: 18px;">date_range</mat-icon>
              <span class="font-bold mr-1">Validez:</span>
              <span>{{ package.day }} {{ package.day > 1 ? 'días' : 'día' }}</span>
            </div>
          </mat-card-content>

          <mat-card-actions class="flex justify-center">
            <button mat-raised-button color="primary">
              Seleccionar
            </button>
          </mat-card-actions>

        </mat-card>
      </div>

      <div *ngIf="filteredPackages.length === 0" class="text-center py-12">
        <mat-icon class="text-gray-400" style="font-size: 64px; width: 64px; height: 64px;">search_off</mat-icon>
        <p class="text-gray-500 mt-4">No se encontraron paquetes para este país</p>
      </div>
    </div>

  </div>

  <!-- Spinner de carga -->
  <div *ngIf="showSpinner" class="loading-overlay">
    <mat-spinner diameter="50"></mat-spinner>
  </div>

</div>
